import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VpnTypeEditorPipe } from "./pipes/vpn-type-editor.pipe";

@NgModule({
  declarations: [VpnTypeEditorPipe],
  imports: [CommonModule],
  exports: [VpnTypeEditorPipe],
})
export class ForceDirectedGraphModule {}
